import { createStore } from 'redux';


const container = createStore((state = {}) => state);


export default container;